<template>
  <SafeHarborStagingEnvironmentsTable
    :service="service"
    :staging-environments="stagingEnvironments"
    :status="getStatus()"
    type="site"
  />
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import SafeHarborStagingEnvironmentsTable from "@/components/smart/tables/SafeHarborStagingEnvironmentsTable";
import Status from "@/classes/Status";
import store from "@/store";

export default {
  name: "SafeHarborStagingEnvironmentsPage",
  components: { SafeHarborStagingEnvironmentsTable },
  setup() {
    const service = computed(() => store.getters["plans/getItem"]);
    const stagingEnvironments = computed(
      () => store.getters["safeHarbor/getSiteStagingEnvironments"]
    );
    const status = computed(() => store.getters["safeHarbor/getSiteStagingEnvironmentsStatus"]);
    const isUpdating = computed(() =>
      store.getters["safeHarbor/isStagingEnvironmentUpdating"](service.value.id)
    );

    const loadingStatus = new Status(Status.LOADING);
    const getStatus = () => (isUpdating.value ? loadingStatus : status.value);

    onMounted(() => {
      store.dispatch("safeHarbor/getSiteStagingEnvironments", service.value.cloudAccount.id);
    });

    return {
      getStatus,
      service,
      stagingEnvironments,
    };
  },
};
</script>
